import { useContext, useEffect } from "react";
import { StoreContextMain } from "../../Context/StoreContextMain";
import { CardOrder } from "../../Components/Cards/CardOrder";
import { useNavigate } from "react-router-dom";
import { CardDetailPayment } from "../Components";
import { PaymentContext } from "../Context/PaymentContext";

export const DetailsPayment = () => {
  const { store } = useContext(StoreContextMain);
  const { payment, getSum } = useContext(PaymentContext);

  const navigate = useNavigate();

  const handleContinue = () => {
    if (store.length === 0) {
      return navigate("/");
    }
    navigate("/payment/personal-information");
  };
  //document.getElementById("iconNavbarSidenav").click();

  
  return (
    <div className="container mt-3" style={{ background: 'transparent' }}>
      <div className="card shadow-none p-0" style={{ boxShadow: 'none' }}>
        <div className="card-header">
          <h5 className="card-title">Detalles de la compra</h5>
        </div>
        <div className="mt-4 row p-3">
          <div className="col-md-6">
            {
              store?.map((item, index) => (
                <CardOrder
                  key={index}
                  id={item.id}
                  category_id={item.category_id}
                  order_id={item.order}
                  title={item.title}
                  image={item.image}
                  price={item.price}
                  color={item.color}
                  size={item.size}
                  amount={item.amount}
                  amount_max={item.amount_max}
                  enableFeacture={true}
                />
              ))
            }
          </div>
          <div className="col-md-6">
            <CardDetailPayment
              title="Detalles de la compra"
              totalProducts={payment?.totalProducts}
              iva={payment?.iva}
              total={payment.productsList?.reduce(getSum, 0)}
              productsList={payment?.productsList}
            />
          </div>
          <div className="d-flex flex-row justify-content-end mt-3">
            
            <button className="btn btn-primary" onClick={handleContinue}>
              Continuar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
